/** @format */
import { Box, Card, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocales } from "locales";

const ContactCard = () => {
  const theme = useTheme();
  const { t } = useLocales();
  return (
    <Box component={Card} boxShadow={0} border={`1px solid ${theme.palette.divider}`}>
      <Box padding={{ xs: 2, sm: 3 }}>
        <Typography
          sx={{
            fontWeight: "700",
          }}
          gutterBottom
        >
          {t("privacyWhoToContact")}
        </Typography>
        <Typography
          variant={"body2"}
          color={"text.secondary"}
          sx={{
            marginBottom: 2,
          }}
        >
          {t("privacyHaveQuestions")}
        </Typography>
        <Typography variant={"subtitle2"}>
          hello@made.live
          <br />
          2933 30th Ave
          <br />
          Vernon, BC
          <br />
          Canada
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactCard;
